import { EffectCallback, DependencyList, useRef, useEffect } from "react";

/**
 * A custom useEffect hook that only triggers on updates, not on initial mount
 * @param {Function} effect
 * @param {Array<any>} dependencies
 */
export const useEffectAfterMount = (effect: EffectCallback, dependencies: DependencyList | undefined = []) => {
  const mounted = useRef(true);

  useEffect(() => {
    if (!mounted.current) {
      return effect()
    }
    mounted.current = false
  }, dependencies)
}
